const fragment = `
  id
  url
  headers
  mappedFields
  lastSyncDate
  type
  status
  syncLogs
  dataProvider
  builtOptionsReport {
    entries
    lastSyncDate
    reportStatus
  }
`;

export const listExternalDataSourcesQuery = `
  query ListExternalDataSources($filter: ExternalDataSourceFilterInput) {
    items: listExternalDataSources(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getExternalDataSourceQuery = `
  query GetExternalDataSource($id: Int, $dataProvider: String, $companyId: Int) {
    item: getExternalDataSource(id: $id, dataProvider: $dataProvider, companyId: $companyId) {
      ${fragment}
    }
  }
`;

export const createExternalDataSourceQuery = `
  mutation CreateExternalDataSource(
    $input: CreateExternalDataSourceInput!
  ) {
    item: createExternalDataSource(input: $input) {
      ${fragment}
    }
  }
`;

export const updateExternalDataSourceQuery = `
  mutation UpdateExternalDataSource(
    $input: UpdateExternalDataSourceInput!
  ) {
    item: updateExternalDataSource(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteExternalDataSourceQuery = `
  mutation DeleteExternalDataSource(
    $id: Int!
   ) {
    item: deleteExternalDataSource(id: $id) {
      ${fragment}
    }
   }
`;

export const startSyncExternalDataSourceQuery = `
  mutation StartSyncExternalDataSource(
    $id: Int!
  ) {
    item: syncExternalDataSource(id: $id) {
      ${fragment}
    }
  }
`;

export const getBuiltOptionsReportQuery = `
  mutation GetBuiltOptionsReport(
    $id: Int!
  ) {
    item: getBuiltOptionsReport(id: $id) {
      ${fragment}
    }
  }
`;
